import Link from 'next/link'
import Image from 'next/image'
import { HTMLAttributeAnchorTarget } from 'react'

export function LinkItem({
  href,
  text,
  icon,
  target,
  className,
  onClick,
}: {
  href: string
  text: string
  icon?: 'external'
  target?: HTMLAttributeAnchorTarget
  className?: string
  onClick?: () => void
}) {
  return (
    <Link
      href={href}
      className={`block lg:inline-flex items-center hover:text-gray-600 ${className || ''}`}
      target={target}
      onClick={onClick}
      prefetch={false}
    >
      <span>
        {text}
        {icon === 'external' && (
          <Image
            className="ml-2 inline-block"
            src="/external.svg"
            alt=""
            width={12}
            height={12}
          />
        )}
      </span>
    </Link>
  )
}
